<div class="container-ffurflen">
  <span class="eitem-marcio"><fa-icon icon="times-circle"></fa-icon> {{ "ui.itemrequiringattention" | translate }}</span>
  <span class="eitem-marcio"><strong>M</strong> {{ "ui.monitor" | translate }}</span>
  <span class="eitem-marcio"><strong>N/A</strong> {{ "ui.notapplicable" | translate }}</span>
  <span class="eitem-marcio"><strong>NC</strong> {{ "ui.notchecked" | translate }}</span>
  <span class="eitem-marcio"><fa-icon icon="check-circle"></fa-icon> {{ "ui.serviceable" | translate }}</span>
</div>

<mat-accordion class="accordion" [multi]="true">
  @for (field of field.fieldGroup; track field; let i = $index) {
    <mat-expansion-panel class="container-panel">
      <mat-expansion-panel-header class="header-panel">
        <mat-panel-title>
          <b>{{ model[i].teitl | translate | uppercase }}</b>
        </mat-panel-title>
      </mat-expansion-panel-header>
  
        <formly-group [field]="field"></formly-group>
      
    </mat-expansion-panel>
  }
</mat-accordion>
